var TEN_YEARS_IN_SECONDS, setSiteCookies;

TEN_YEARS_IN_SECONDS = 60 * 60 * 24 * 365 * 10;

module.exports = setSiteCookies = function(cookies, seconds) {
  var cookieDomain, key, results, val;
  if (seconds == null) {
    seconds = TEN_YEARS_IN_SECONDS;
  }
  cookieDomain = setSiteCookies.cookieDomain || (setSiteCookies.cookieDomain = $('head').data('domain'));
  results = [];
  for (key in cookies) {
    val = cookies[key];
    if (val != null) {
      results.push(Cookie.set(key, val, seconds, cookieDomain));
    } else {
      results.push(Cookie.unset(key, cookieDomain));
    }
  }
  return results;
};

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL1VzZXJzL3NraW0vc2xzL2NvcmUvZnJvbnRlbmQvZ3JvdXBvbl9tb2R1bGVzL3NldFNpdGVDb29raWVzLmNvZmZlZSIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi9Vc2Vycy9za2ltL3Nscy9jb3JlL2Zyb250ZW5kL2dyb3Vwb25fbW9kdWxlcy9zZXRTaXRlQ29va2llcy5jb2ZmZWUiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsSUFBQTs7QUFBQSxvQkFBQSxHQUF1QixFQUFBLEdBQUssRUFBTCxHQUFVLEVBQVYsR0FBZSxHQUFmLEdBQXFCOztBQUc1QyxNQUFNLENBQUMsT0FBUCxHQUFpQixjQUFBLEdBQWlCLFNBQUMsT0FBRCxFQUFVLE9BQVY7QUFDaEMsTUFBQTs7SUFEMEMsVUFBVTs7RUFDcEQsWUFBQSxHQUFlLGNBQWMsQ0FBQyxpQkFBZixjQUFjLENBQUMsZUFBaUIsQ0FBQSxDQUFFLE1BQUYsQ0FBUyxDQUFDLElBQVYsQ0FBZSxRQUFmO0FBQy9DO09BQUEsY0FBQTs7SUFDRSxJQUFHLFdBQUg7bUJBQ0UsTUFBTSxDQUFDLEdBQVAsQ0FBVyxHQUFYLEVBQWdCLEdBQWhCLEVBQXFCLE9BQXJCLEVBQThCLFlBQTlCLEdBREY7S0FBQSxNQUFBO21CQUdFLE1BQU0sQ0FBQyxLQUFQLENBQWEsR0FBYixFQUFrQixZQUFsQixHQUhGOztBQURGOztBQUZnQyJ9
